import forcyteService from './ForcyteService'

const BASE_URL = 'donor-portal/v2'

class PublicService {
  async getProcedureTypes() {
    return forcyteService.get(`${BASE_URL}/procedure-types`)
  }
  async getDonorCenters() {
    return forcyteService.get(`${BASE_URL}/donor-centers`)
  }
  async getDonorCenterCalendar(params) {
    return forcyteService.get(`${BASE_URL}/donor-center-calendar`, {
      params,
    })
  }
  async getOperationSchedules(params) {
    return forcyteService.get(`${BASE_URL}/drives-sessions-schedule`, {
      params,
    })
  }
  async getOperationLocations(params) {
    return forcyteService.get(`${BASE_URL}/drives-sessions-locations`, {
      params,
    })
  }
  async getAppointmentAvailability(params, signal) {
    return forcyteService.get(`${BASE_URL}/appointment-availability`, {
      params,
      signal,
    })
  }
  async getDriveSessionSingle(params, signal) {
    return forcyteService.get(`${BASE_URL}/drive-session-single`, {
      params,
      signal,
    })
  }
  async getZipCodeSearch(params) {
    return forcyteService.get(`${BASE_URL}/zip-code-search`, {
      params,
    })
  }
  async getCitySearch(params) {
    return forcyteService.get(`${BASE_URL}/city-search`, {
      params,
    })
  }
  async getCities() {
    return forcyteService.get(`${BASE_URL}/cities`)
  }
  async getSponsors() {
    return forcyteService.get(`${BASE_URL}/sponsors`)
  }
  async getSponsorSearch(params) {
    return forcyteService.get(`${BASE_URL}/sponsor-search`, {
      params,
    })
  }
  async getPrivateDriveSearch(params) {
    return forcyteService.get(`${BASE_URL}/private-drive-search`, {
      params,
    })
  }
}

const publicService = new PublicService()
export default publicService
